import React, { useEffect, useState } from 'react';

// Styles & Assets
import styles from './Toast.module.css';
import { IoCheckmarkCircle, IoAlertCircle, IoInformationCircle, IoClose } from 'react-icons/io5';
import { BsFillXCircleFill } from 'react-icons/bs';

// Hooks
import { useToast } from '../../../hooks/useToast';

// Interface
import { IToast } from '../../../interfaces/Toast';

const toastTypes = {
    success: {
        Icon: IoCheckmarkCircle,
        clase: styles.msgGreen,
    },
    warning: {
        Icon: IoAlertCircle,
        clase: styles.msgYellow,
    },
    info: {
        Icon: IoInformationCircle,
        clase: styles.msgGrey,
    },
    error: {
        Icon: BsFillXCircleFill,
        clase: styles.msgRed,
    },
};

const Toast: React.FC<IToast> = ({ message, type, id }) => {

    const { remove } = useToast();

    const { clase, Icon } = toastTypes[type];

    const [dismissed, setDismissed] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            setDismissed(true);
            setTimeout(() => {
                remove(id);
            }, 400);
        }, 4000);
    }, [id, remove]);

    return (
        <div className={`${styles.toast} ${clase} ${dismissed ? styles.toastDismissed : ''}`}>
            <Icon style={{ width: '20px', height: '20px' }} />
            <div>{message}</div>
            <button onClick={() => remove(id)} className={styles.btnClose}>
                <IoClose />
            </button>
        </div>
    );
};

export default Toast;